const FONT_SIZE_SMALL = ".875em";
const FONT_SIZE_NORMAL = "1em";

const H2_SIZE = "1.5625em";

const FONT_WEIGHT_THIN = "100";
const FONT_WEIGHT_EXTRA_LIGHT = "200";
const FONT_WEIGHT_LIGHT = "300";
const FONT_WEIGHT_NORMAL = "400";
const FONT_WEIGHT_MEDIUM = "500";
const FONT_WEIGHT_SEMI_BOLD = "600";
const FONT_WEIGHT_BOLD = "700";
const FONT_WEIGHT_EXTRA_BOLD = "800";
const FONT_WEIGHT_HEAVY = "900";

export {
  FONT_SIZE_SMALL,
  FONT_SIZE_NORMAL,
  H2_SIZE,
  FONT_WEIGHT_THIN,
  FONT_WEIGHT_EXTRA_LIGHT,
  FONT_WEIGHT_LIGHT,
  FONT_WEIGHT_NORMAL,
  FONT_WEIGHT_MEDIUM,
  FONT_WEIGHT_SEMI_BOLD,
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_EXTRA_BOLD,
  FONT_WEIGHT_HEAVY,
};
